<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" height="25" alt="VirtuPhone LLC">
        <img class="navbar-brand-minimized" src="img/logo-symbol.png" width="30" height="30" alt="VirtuPhone LLC">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="$can('view', 'systemSettings')" class="px-3" to="/system"><i class="icon-speedometer mr-1"></i>System</b-nav-item>
        <!-- <b-nav-item class="px-3" to="/numbers"><i class="icon-phone mr-1"></i>Numbers</b-nav-item> -->
        <!-- <b-nav-item class="px-3" to="/provisioning"><i class="icon-energy mr-1"></i>Provisioning</b-nav-item> -->
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">&copy; {{ year }} VirtuPhone LLC</span>
      </div>
    </TheFooter>
    <select-account></select-account>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import SelectAccount from '../views/modals/SelectAccount'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { mapGetters } from 'vuex'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SelectAccount,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    ...mapGetters({
      account: 'global/account'
    }),
    accountName() {
      if (this.account) {
        return this.account.name
      } else {
        return null
      }
    },
    year () {
      return this.$moment().format('YYYY')
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    nav () {
      const nav = []
      nav.push(
        {
          name: 'Back to Client',
          url: '/dashboard',
          icon: 'icon-arrow-left'
        }
      )

      nav.push(
        {
          divider: true
        }
      )

      nav.push(
        {
          name: 'Dashboard',
          url: '/system/dashboard',
          icon: 'icon-speedometer'
        }
      )

      if (this.$can('manage', 'accounts')) {
        nav.push(
          {
            name: 'Accounts',
            url: '/system/accounts',
            icon: 'icon-list'
          }
        )
      }

      if (this.$can('manage', 'provisioning')) {
        nav.push(
          {
            name: 'Provisioning',
            url: '/system/provisioning',
            icon: 'icon-energy'
          }
        )
      }

      if (this.$can('manage', 'allNumbers')) {
        nav.push(
          {
            name: 'Numbers',
            url: '/system/numbers',
            icon: 'icon-globe'
          }
        )
      }

      if (this.$can('manage', 'systemRoles')) {
        nav.push(
          {
            name: 'Roles',
            url: '/system/roles',
            icon: 'icon-user-follow'
          }
        )
      }

      return nav
    }
  },
  methods: {
    selectAccount () {
      this.$bus.$emit('modal:selectAccount')
    }
  }
}
</script>
<style lang="scss">
.nav-search {
  width: 300px;
}

ul {
  &.nav {
    .nav-divider {
      margin-top: 5px;
      height: 5px;
      border-top: 1px solid rgba(255,255,255,.5);
    }
  }
}

</style>
